import type { ReviewStatistics } from '~~/shared/globalTypes/reviews';

export default function parseStatisticsData(statistics: ReviewStatistics | undefined, totalResults: number) {
  if (!statistics || !totalResults) return null;
  return {
    averageRating: statistics?.averageOverallRating,
    totalCount: statistics?.totalReviewCount,
    // append countPerRating if ratingDistribution is defined
    ...(statistics?.ratingDistribution && {
      countPerRating: statistics.ratingDistribution
        .sort((a, b) => b.ratingValue - a.ratingValue)
        .map((x) => ({
          rating: x.ratingValue,
          count: x.count,
          percentage: (x.count / statistics.totalReviewCount) * 100,
        })),
    }),
    // append sliders if averageSliders is defined
    ...(statistics?.averageSliders && {
      sliders: Object.values(statistics.averageSliders).map((obj) => ({
        title: obj.label,
        value: obj.value,
        valueRange: obj.valueRange,
        minLabel: obj.minLabel,
        midLabel: obj.midLabel,
        maxLabel: obj.maxLabel,
      })),
    }),
  };
}
